import { Grid } from '@mui/material';
import { Field, FieldArray } from 'formik';

import { IScoringSystemFragment } from 'graphql/types';

import { TextField } from '../TextField/TextField';

interface IProps {
    scoringSystems?: IScoringSystemFragment[];
}

export const ScoringSystemFields = ({ scoringSystems }: IProps) => {
    if (!scoringSystems?.length) return null;

    return (
        <FieldArray
            name="scores"
            render={() => (
                <Grid container columnSpacing={2}>
                    {scoringSystems.map((scoringSystem, index) => (
                        <Grid
                            key={`score-${index}`}
                            size={{
                                sm: 4,
                                xs: 12,
                            }}
                        >
                            <Field
                                component={TextField}
                                label={scoringSystem.namePlural}
                                name={`scores[${index}].score`}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}
        />
    );
};
